import { ReactNode, useEffect } from 'react'
import { createPortal } from 'react-dom'

interface ModalProps {
  isOpen: boolean
  onClose: () => void
  children: ReactNode
  maxWidth?: string
  maxHeight?: string
}

function Modal({ isOpen, onClose, children, maxWidth = '768px', maxHeight = '90vh' }: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }

    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [isOpen])

  if (!isOpen) return null

  const modalContent = (
    <div 
      className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-75 d-flex align-items-center justify-content-center p-4"
      style={{
        zIndex: 2147483647, // Maximum possible z-index
        backdropFilter: 'blur(2px)'
      }}
      onClick={onClose}
    >
      <div 
        className="bg-white rounded shadow-lg w-100 position-relative"
        style={{
          maxWidth: maxWidth,
          maxHeight: maxHeight,
          overflowY: 'auto'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  )

  return createPortal(modalContent, document.body)
}

export default Modal